import { loadAirwallex, createElement, getElement } from 'airwallex-payment-elements'


class AirwallexClass {
  /**
   * 支付方式
   */
  #enumPayWay = {
    card: ['card'],
    ali_cn: ['alipaycn'],
    ali_hk: ['alipayhk'],
    doku: ['doku_ewallet'],
    dana: ['dana'],
    kakao: ['kakaopay'],
    google: ['googlepay'],
  }
  /**
   * 支付币种
   */
  #enumCoin = {
    card: 'USD',
    ali_cn: 'USD',
    ali_hk: 'HKD',
    doku: 'IDR',
    dana: 'IDR',
    kakao: 'KRW',
    google: 'USD',
  }

  constructor() {
    this.onSuccess = null
  }

  /**
   * Airwallex处理
   */

  airwallexOptionDeal = {
    that: this,
    baseOption(type) {
      return {
        methods: this.that.#enumPayWay[type],
        currency: this.that.#enumCoin[type]
      }
    },
    card() {
      return this.baseOption('card')
    },
    google() {
      return {
        ...this.baseOption('google'),
        googlePayRequestOptions: {
          countryCode: 'HK',
          merchantInfo: {
            merchantName: 'Airwallex',
          },
        }
      }
    },
    ali_cn() {
      return this.baseOption('ali_cn')
    },
    ali_hk() {
      return this.baseOption('ali_hk')
    },
    doku() {
      return this.baseOption('doku')
    },
    dana() {
      return this.baseOption('dana')
    },
    kakao() {
      return this.baseOption('kakao')
    },


  }

  init(
    env,
    options
  ) {
    loadAirwallex({
      env,
      origin: window.location.origin
    }).then(() => {
      console.log(options)
      const element = createElement('dropIn', {
        ...options
      });
      element.mount('dropIn');
    })
  }

  // onSuccess() {
  //     if (this.ProvideIsJump) {
  //         this.$router.push('/my/orders')
  //     } else {
  //         this.$router.push('/my/transactions')
  //     }
  // }

  loadFunction(type, intent_id, client_secret) {
    const env = location.host === 'asoworld.com' ? 'prod' : 'demo'
    console.log(env)

    /**
       * env: 环境
       * intent_id: 支付id
       * client_secret: 支付密钥
       * currency: 货币
       * methods: 支付方式
       */
    this.init(
      env,
      this.createElementOptionsForAirwallex(
        type,
        {
          intent_id,
          client_secret
        }
      )
    );

    // 生成支付组件
    const domElement = document.getElementById('dropIn');
    // 挂载事件
    // domElement.addEventListener('onReady', onReady);
    domElement.addEventListener('onSuccess', this.onSuccess);
    // domElement.addEventListener('onError', onError);
  }

  cancelFunction() {
    const domElement = document.getElementById('dropIn');
    domElement.removeEventListener('onSuccess', this.onSuccess);
    getElement('dropIn').unmount();
  }

  /**
   * 
   * @param {支付类型} type 
   * @param {基础配置} baseOptions 
   * @returns 
   */
  createElementOptionsForAirwallex(type, baseOptions) {
    console.log(type)
    if (!type) return {}
    let op = this.airwallexOptionDeal[type]()
    return {
      ...baseOptions,
      ...op
    }
  }
}

export {
  AirwallexClass
}